import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';

import { loginSSOScreen } from 'router/routes';

const buttonStyles = ({ breakpoints }) => ({
  alignSelf: 'center',
  border: '1px solid #8C8C8C',
  backgroundColor: 'transparent !important',
  borderRadius: 0,
  padding: '12px 8px',
  fontSize: '15px',
  color: '#5E5E5E !important',
  [breakpoints.up('xxl')]: {
    alignSelf: 'flex-start',
  },
});

const SSOAuthButton = () => {
  const { push, location } = useHistory();

  return (
    <Button sx={buttonStyles} onClick={() => push({ ...location, pathname: loginSSOScreen })}>
      Sign in with SSO
    </Button>
  );
};

export default SSOAuthButton;
